import { ApplicationSectionHeading } from '../ApplicationSectionHeading';
import { Box, Grid, Typography } from '@mui/material';
import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNationalityList } from '../../redux-store/actions';
import { FatcaMdmsData } from '../../redux-store/actions/application';
import {
  Applicant,
  FatcaMdms,
  nonIndividualMdmsQuestionsFatca,
  tinCountriesList,
  tinValidationProps,
} from '../../redux-store/types/api-types';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import {
  AssignAnsAndVisibilityForInitialFatca,
  BorderedTextField,
  FatcaDatePicker,
  Group,
  OpenTextField,
  SectionHeader,
  SingleChoiceDropdownWithInfo,
  SingleChoiceRadio,
} from '../NonIndividualInvestor/fatca';
import { KeyValue } from '../ApplicationDetails/contributor';
import { RootStateType } from '../../redux-store/reducers';
import { useFeatureToggles, useMdmsFatcaData } from '../../utils/toggler';
import { TIN_VARIFICATION } from '../../redux-store/types/onBoarding';
// import { doc } from '../investors/documentDetails';
import { getTinCountriesList } from '../../redux-store/actions/onBoarding';
import { checkValidationBasedOnDate } from '../../utils/utilityFunctions';

interface Values {
  applicants: {
    fatcadetail: nonIndividualMdmsQuestionsFatca;
    fatcaCrsDocumentCheck: boolean | null;
    typeOfAddressProvidedAtKRA: string;
    tinValidation: tinValidationProps[] | null;
    // documents: doc[];
  }[];
}

export default function Fatca({
  applicants = [],
}: {
  applicants: Partial<Applicant>[];
}): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const [fatcaData, setFatcaData] = useState<Values>();
  const dispatch = useDispatch();
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const fatca = useMdmsFatcaData();
  const dateFeatureToggles = useFeatureToggles();
  const [tinCountries, setTinCountries] = useState<tinCountriesList[]>([]);
  const { fatcaValidationDate, tin_declaration_validation_date } = dateFeatureToggles;
  useEffect(() => {
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        if (
          tin_declaration_validation_date &&
          checkValidationBasedOnDate(application?.createdAt || '', tin_declaration_validation_date)
        ) {
          //   const res = (await dispatch(getTinCountriesList())) as unknown as tinCountriesList[];
          //   setTinCountries(res);
          // } else {
          setTinCountries(
            nationalitiesMdmsMasters.countries.map((country) => ({
              countryName: country?.nationality,
              countryCode: country?.code,
            }))
          );
        }
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [fatcaValidationDate, application]);

  useEffect(() => {
    (async function () {
      if (fatca && application) {
        const response = (await dispatch(FatcaMdmsData(fatca))) as unknown as FatcaMdms;
        if (response.fatca_questions) {
          const _applicants = {
            applicants: applicants.map((applicant) => {
              const {
                fatcadetail: existingFatcaDetails = null,
                documents,
                isTinVerified = [],
              } = applicant || {};
              return {
                fatcadetail: existingFatcaDetails
                  ? AssignAnsAndVisibilityForInitialFatca(
                      response.fatca_questions,
                      existingFatcaDetails
                    )
                  : [],
                fatcaCrsDocumentCheck: applicant.fatcaCrsDocumentCheck,
                typeOfAddressProvidedAtKRA: applicant.typeOfAddressProvidedAtKRA,
                tinValidation: isTinVerified.map((item) => ({ isTinVerified: item })),
                documents: documents,
              };
            }),
          };
          setFatcaData(_applicants as Values);
        }
      }
    })();
  }, [fatca, application]);

  return (
    <Box
      sx={{
        bgcolor: 'white',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
        borderRadius: '10px',
      }}
      mt={5}>
      <Box sx={{ p: 2 }}>
        <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
          <ApplicationSectionHeading title="FATCA" sx={{ mb: 3 }} />
          <Formik
            initialValues={fatcaData as Values}
            enableReinitialize={true}
            onSubmit={() => {
              console.log('this action should not be trigered');
            }}>
            {({ values, setValues }) => (
              <Grid
                container
                rowSpacing={1}
                //columnSpacing={5}
                sx={{
                  width: '100%',
                  ml: 0,
                  '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
                }}>
                {values?.applicants.map((applicant, idx) => (
                  <React.Fragment key={idx}>
                    {!applicant.fatcaCrsDocumentCheck && applicant.fatcadetail.length === 0 && (
                      <Grid
                        xs={12}
                        sm={12}
                        sx={{
                          fontSize: 18,
                          fontWeight: 600,
                          color: 'common.black',
                          textAlign: 'center',
                          my: 3,
                        }}>
                        No Fatca Details
                      </Grid>
                    )}
                    {applicant.fatcaCrsDocumentCheck && (
                      <Grid item xs={12} display="flex" alignItems={'flex-start'}>
                        {/* <Checkbox defaultChecked disabled={true} /> */}
                        <Typography
                          sx={{
                            fontSize: 15,
                            fontWeight: 700,
                            color: 'rgba(0, 0, 0, 0.6)',
                            letterSpacing: '0.5px',
                          }}>
                          {`Wish to upload FATCA-CRS Declaration`}
                        </Typography>
                      </Grid>
                    )}
                    {!applicant?.fatcaCrsDocumentCheck && (
                      <KeyValue
                        title={'Type Of Address Provided At KRA'}
                        description={applicant.typeOfAddressProvidedAtKRA}
                      />
                    )}

                    {!applicant.fatcaCrsDocumentCheck &&
                      applicant.fatcadetail.map((item) => (
                        <React.Fragment key={item.id}>
                          {item.isVisible &&
                            item.section_header &&
                            item.question_type !== 'group' && (
                              <SectionHeader value={item.section_header} />
                            )}
                          {item.isVisible && item.question_type === 'single_choice_radio' && (
                            <SingleChoiceRadio
                              data={item}
                              values={applicant.fatcadetail}
                              formValuesIndex={idx}
                              questionId={item.id}
                              disabled={true}
                            />
                          )}
                          {item.isVisible && item.question_type === 'group' && (
                            <Group
                              data={item}
                              formValuesIndex={idx}
                              values={applicant.fatcadetail}
                              _applicants={applicants}
                              disabled={true}
                              nationalityDropdown={mdmsCountriesList}
                              setValue={() => {
                                console.log('clicked');
                              }}
                              createdAt={application?.createdAt || ''}
                              tinVerification={applicant.tinValidation || []}
                              documents={[]}
                              tinCountries={tinCountries}
                            />
                          )}
                          {item.isVisible && item.question_type === 'open_text_field' && (
                            <OpenTextField
                              text={item.question_text}
                              applicantsIndex={idx}
                              questionId={item.id}
                              placeHolder={item?.placeholder || 'Please enter text here'}
                              isMandatory={item.isMandatory}
                              disabled={true}
                            />
                          )}
                          {item.isVisible && item.question_type === 'bordered_text_field' && (
                            <>
                              {item.header && (
                                <Typography
                                  sx={{
                                    fontFamily: 'Work Sans,sans-serif',
                                    fontWeight: 400,
                                    fontSize: '16px',
                                    pt: 1,
                                    pb: 1,
                                    pl: 1,
                                    width: '100%',
                                  }}>
                                  {item.header}
                                </Typography>
                              )}{' '}
                              <Grid item xs={12} sm={6} sx={{ pr: { xs: 0, sm: '30px' }, pt: 2 }}>
                                <BorderedTextField
                                  applicantsIndex={idx}
                                  questionId={item.id}
                                  label={item.question_text}
                                  placeHolder={item?.placeholder || 'Please enter text here'}
                                  isMandatory={item.isMandatory}
                                  disabled={true}
                                />
                              </Grid>
                            </>
                          )}
                          {item.isVisible &&
                            item.question_type === 'single_choice_dropdown_withInfo' && (
                              <Grid item xs={12} sm={6} sx={{ pt: 2 }}>
                                <SingleChoiceDropdownWithInfo
                                  applicantsIndex={idx}
                                  questionId={item.id}
                                  label={item.question_text}
                                  options={item.options || []}
                                  isMandatory={item.isMandatory}
                                  data={item}
                                  values={applicant.fatcadetail}
                                  disabled={true}
                                  backendKey={item.backend_key}
                                />
                              </Grid>
                            )}
                          {item.isVisible && item.question_type === 'date' && (
                            <Grid xs={12} sm={6} sx={{ px: { xs: 0, sm: '30px' }, pt: 1 }}>
                              <FatcaDatePicker
                                applicantsIndex={idx}
                                questionId={item.id}
                                label={item.question_text}
                                isMandatory={item.isMandatory}
                                disabled={true}
                              />
                            </Grid>
                          )}
                        </React.Fragment>
                      ))}
                  </React.Fragment>
                ))}
              </Grid>
            )}
          </Formik>
        </Grid>
      </Box>
    </Box>
  );
}
